export function useLastNotificationResponse() {
  return null;
}
